var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { inject, observer } from 'mobx-react';
import { Stack, Divider } from '@mui/material';
import VideoSettingsEditor from './video-settings-editor';
import PhotoSettingsEditor from './photo-settings-editor';
import SignatureSettingsEditor from './signature-settings-editor';
import MessagesSettingsEditor from './messages-settings-editor';
var PhotoVideoSettings = /** @class */ (function (_super) {
    __extends(PhotoVideoSettings, _super);
    function PhotoVideoSettings(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    Object.defineProperty(PhotoVideoSettings.prototype, "render", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return (_jsxs(Stack, __assign({ spacing: 2, overflow: "auto" }, { children: [_jsx(VideoSettingsEditor, {}, void 0), _jsx(Divider, {}, void 0), _jsx(PhotoSettingsEditor, {}, void 0), _jsx(Divider, {}, void 0), _jsx(SignatureSettingsEditor, {}, void 0), _jsx(Divider, {}, void 0), _jsx(MessagesSettingsEditor, {}, void 0)] }), void 0));
        }
    });
    PhotoVideoSettings = __decorate([
        inject('caseTypesStore'),
        inject('languageStore'),
        observer
    ], PhotoVideoSettings);
    return PhotoVideoSettings;
}(React.Component));
export default PhotoVideoSettings;
